// extracted by mini-css-extract-plugin
export default {"layout":"DesktopLayout_layout__qOfxB","mockup":"DesktopLayout_mockup__YvVAl","image":"DesktopLayout_image__ZQ0MG"};